import { apiActions } from "../../../_core/api";
import { Middleware } from "redux";
import { IStore } from "../../../store";
import orb3Actions, {
	EORB3Actions,
	EORB3Constants,
	TORB3Actions,
} from "../actions";
import { jobActions } from "../../../_core/job";
import { IAuthActions } from "../../auth/actions";
import { commonUtils } from "../../../_common";
import { TORB3BackendRecord } from "../@types";
import { EMARPOLDocuments, EMARPOLModelName } from "redux/app/marpol/@types";

const orb3HistoryMiddleware: Middleware<{}, IStore> =
	({ dispatch, getState }) =>
	(next) =>
	(action: TORB3Actions | IAuthActions) => {
		switch (action.type) {
			case EORB3Actions.HISTORY_LOAD: {
				next(action);
				const job = jobActions(EORB3Constants.FEATURE, action.type);
				const { providedFilters: filters } = action.payload;
				dispatch(orb3Actions.document.setFilter(filters));
				dispatch(
					apiActions.apiRequest<{ logs: { docs: TORB3BackendRecord[] } }>({
						feature: action.type,
						method: "GET",
						url: EORB3Constants.API,
						queryParams: {
							vesselId: filters.vesselId,
							marpolType: EMARPOLDocuments.ORB3,
							modelName: EMARPOLModelName.MARPOL,
							weekStart: filters.startDate,
							weekEnd: filters.endDate,
							state: {
								$eq: filters?.state ?? undefined,
							},
							sortOrder: filters?.sortOrder ?? undefined,
						},
						preExecute() {
							dispatch(job.active({}));
						},
						postExecute: {
							onSuccess({ data }) {
								const orb3Records = data.logs.docs.filter(
									(doc) => doc.marpolType === EMARPOLDocuments.ORB3,
								);
								dispatch(
									orb3Actions.document.historySet(
										commonUtils.arrayToObject(orb3Records),
									),
								);
								dispatch(job.success({}));
							},
							onError() {
								dispatch(job.error({}));
							},
							finally() {
								dispatch(job.idle({}));
							},
						},
					}),
				);
				break;
			}
			default: {
				next(action);
				break;
			}
		}
	};
export default orb3HistoryMiddleware;
